'use client'

import { createContext, useContext } from 'react'

import { AppBridgeAction, AppBridgeState, NotificationGrantedStatus } from '@podo/native'

export type OSType = 'IOS' | 'IPAD' | 'MACOS' | 'DESKTOP' | 'ANDROID' | 'ANDROID_TABLET'
export type AppleOSType = 'IOS' | 'IPAD' | 'MACOS'
export type AndroidOSType = 'ANDROID' | 'ANDROID_TABLET'

// requestExitApp / lastBackPressAt 은 안드로이드 뒤로가기 내부 처리 전용이라 context 로는 노출하지 않는다.
// push opt-in 상태와 action은 AppBridge 계약을 그대로 상속해 Web overlay에서 사용한다.
export interface NativeBridgeStore
  extends Omit<AppBridgeAction, 'requestExitApp'>, Omit<AppBridgeState, 'lastBackPressAt'> {
  consumePushOptInStep1ForCurrentLaunch: (webviewUrl: string) => Promise<void>
  from: Nullable<'WEB' | 'APP'>
  os: Nullable<OSType>
  notificationPermissionStatus: Nullable<NotificationGrantedStatus>
  pushToken: Nullable<string>
  runtimeVersion: Nullable<string>
  latestRuntimeVersion: Nullable<string>
  userAgent: Nullable<string>
}

export const NativeBridgeStoreContext = createContext<NativeBridgeStore | null>(null)

export const useNativeBridgeStore = () => {
  const context = useContext(NativeBridgeStoreContext)

  if (!context) {
    throw new Error('useNativeBridgeStore must be used within a NativeBridgeStoreProvider')
  }

  return context
}
